import { LightNote } from '../models/Note';
import { ETAType } from '../../shared/eta-type.model';

export class BluechatDelivery {

  public deliveryNumber: string;
  public salesOrderNumber: string;
  public status: BluechatDeliveryStatus;
  public origin: BluechatStop;
  public destination: BluechatStop;
  public products: Array<BluechatDeliveryProduct>
  public notes: Array<LightNote>;
  public tripId?: string;

  public static fromDto(bluechatDeliveryDto: any): BluechatDelivery {
    if (!bluechatDeliveryDto) {
      return null;
    }

    const bluechatDelivery          = new BluechatDelivery();
    bluechatDelivery.deliveryNumber = bluechatDeliveryDto.deliveryNumber;
    bluechatDelivery.salesOrderNumber = bluechatDeliveryDto.salesOrderNumber;
    bluechatDelivery.status         = BluechatDeliveryStatus[bluechatDeliveryDto.status];
    bluechatDelivery.origin         = BluechatStop.fromDto(bluechatDeliveryDto.origin);
    bluechatDelivery.destination    = BluechatStop.fromDto(bluechatDeliveryDto.destination);
    bluechatDelivery.tripId         = bluechatDeliveryDto.tripId;
    bluechatDelivery.notes          = bluechatDeliveryDto.notes.map(note => LightNote.fromDto(note));
    bluechatDelivery.products       = bluechatDeliveryDto.products.map(product => BluechatDeliveryProduct.fromDto(product));

    return bluechatDelivery;
  }

  public equals(bluechatDelivery: BluechatDelivery) {
    return this.deliveryNumber === bluechatDelivery.deliveryNumber;
  }
}

export class BluechatStop {
  public glid: string;
  public locationName: string;
  public street: string;
  public city: string;
  public state: string;
  public postalCode: string;
  public countryCode: string;
  public timezoneOffset: string;
  public arrivalDateTime?: string;
  public departureDateTime?: string;
  public latestEtaDateTime?: string;
  public latestEtaType?: ETAType;
  public latestEtaReportId?: string;
  public etaDateTime?: string;
  public etaType?: ETAType;
  public plannedDeliveryDateTime?: string;

  public static fromDto(bluechatStopDto: any): BluechatStop {
    if (bluechatStopDto == null) {
      return null;
    }

    const bluechatStop                   = new BluechatStop();
    bluechatStop.glid                    = bluechatStopDto.glid;
    bluechatStop.locationName            = bluechatStopDto.locationName;
    bluechatStop.street                  = bluechatStopDto.street;
    bluechatStop.city                    = bluechatStopDto.city;
    bluechatStop.state                   = bluechatStopDto.state;
    bluechatStop.postalCode              = bluechatStopDto.postalCode;
    bluechatStop.countryCode             = bluechatStopDto.countryCode;
    bluechatStop.timezoneOffset          = bluechatStopDto.timezoneOffset;
    bluechatStop.arrivalDateTime         = bluechatStopDto.arrivalDateTime;
    bluechatStop.departureDateTime       = bluechatStopDto.departureDateTime;
    bluechatStop.latestEtaDateTime       = bluechatStopDto.latestEtaDateTime;
    bluechatStop.latestEtaType           = ETAType[bluechatStopDto.latestEtaType];
    bluechatStop.etaDateTime             = bluechatStopDto.etaDateTime;
    bluechatStop.etaType                 = ETAType[bluechatStopDto.etaType];
    bluechatStop.plannedDeliveryDateTime = bluechatStopDto.plannedDeliveryDateTime;
    bluechatStop.latestEtaReportId       = bluechatStopDto.latestEtaReportId;
    return bluechatStop;
  }

  public format() {
    return [
      this.locationName,
      this.street,
      this.postalCode,
      this.city,
      this.countryCode
    ].filter(part => part != null)
      .join(', ');
  }
}

export class BluechatDeliveryProduct {
  public productId: string;
  public line: string;
  public description: string;
  public paletNumber: string;
  public weight: string;

  public static fromDto(bluechatDeliveryProductDto: any): BluechatDeliveryProduct {
    if (bluechatDeliveryProductDto == null) {
      return null;
    }

    const bluechatDeliveryProduct       = new BluechatDeliveryProduct();
    bluechatDeliveryProduct.productId   = bluechatDeliveryProductDto.productId;
    bluechatDeliveryProduct.line        = bluechatDeliveryProductDto.line;
    bluechatDeliveryProduct.description = bluechatDeliveryProductDto.description;
    bluechatDeliveryProduct.paletNumber = bluechatDeliveryProductDto.paletNumber;
    bluechatDeliveryProduct.weight      = bluechatDeliveryProductDto.weight;
    return bluechatDeliveryProduct;
  }
}

export enum BluechatDeliveryStatus {
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  PICK_PENDING = 'PICK_PENDING',
  PICKING_UP   = 'PICKING_UP',
  PICKED       = 'PICKED',
  DROPPING     = 'DROPPING',
  DELIVERED    = 'DELIVERED'
}

